import type { AlbumDocument } from "../domain/project";

interface AlbumPreviewProps {
  document: AlbumDocument;
  urls: Record<string, string>;
}

export function AlbumPreview({ document, urls }: AlbumPreviewProps) {
  const cover = document.coverAssetId ? urls[document.coverAssetId] : undefined;
  return (
    <article className={`album-preview template-${document.template}`}>
      <header className="preview-cover">
        <div className="preview-cover-copy">
          <span className="preview-mark">PHOTO FOLIO</span>
          <h2>{document.title}</h2>
          <p>{document.subtitle}</p>
          <div className="preview-meta">
            {document.date ? <span>{document.date}</span> : null}
            {document.location ? <span>{document.location}</span> : null}
          </div>
        </div>
        {cover ? <img src={cover} alt={`${document.title}封面`} /> : <div className="cover-placeholder">等待第一张照片</div>}
      </header>
      <div className="preview-pages">
        {document.pages.map((page) => (
          <figure key={page.id}>
            {urls[page.assetId] ? <img src={urls[page.assetId]} alt={page.title || "影集照片"} /> : <div className="image-skeleton" />}
            <figcaption>
              <div>
                <small>{[page.date, page.location].filter(Boolean).join(" / ")}</small>
                <h3>{page.title}</h3>
              </div>
              <p>{page.caption || "这张照片还没有说明。"}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </article>
  );
}
